import request from '../../../api/request';

export interface FormDataResponseType {
  schools: Array<{ id: number; name: string }>; //Plantel - Facultad
  campuses: Array<{ id: number; name: string }>; //sede
  modalities: Array<{ id: number; name: string }>;
}

export const CONTINUOUS_EDUCATION = {
  GET_FORM_DATA: () =>
    '/maintainers-portal/continuous-education/study-plans/form-data',
};

/**
 * Obtiene los datos para llenar el filtro de planes de estudio de educación continua
 * @returns
 */
export const getFormDataRequest = () => {
  return request<FormDataResponseType>(CONTINUOUS_EDUCATION.GET_FORM_DATA());
};
